import requestFunctions from "../../functions/requestFunctions";


export const state = {
  LANGUAGES_ITEM: {},
  LANGUAGES_LIST: [],
  LANGUAGES_TABLE_DATA: [],
  LANGUAGES_LIST_DATA: [],
  LANGUAGES_TOTAL_ROWS: 0
}

export const getters = {
  GET_LANGUAGES_ITEM: (state) => {
    return state.LANGUAGES_ITEM;
  },
  GET_LANGUAGES_LIST: (state) => {
    return state.LANGUAGES_LIST;
  },
  GET_LANGUAGES_TABLE_DATA: (state) => {
    return state.LANGUAGES_TABLE_DATA;
  },
  GET_LANGUAGES_LIST_DATA: (state) => {
    return state.LANGUAGES_LIST_DATA;
  },
  GET_LANGUAGES_TOTAL_ROWS: (state) => {
    return state.LANGUAGES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_LANGUAGES_ITEM(state, item) {
    state.LANGUAGES_ITEM = item;
  },

  UPDATE_LANGUAGES_LIST(state, list) {
    
    state.LANGUAGES_LIST = list.data;

    state.LANGUAGES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.LANGUAGES_TABLE_DATA = [];
    state.LANGUAGES_LIST_DATA = [];

    list.forEach(el => {

      state.LANGUAGES_TABLE_DATA.push({
        'id'   : el.id,
        'name' : el.name,
        'code' : el.code,
        'uuid' : el.uuid
      });

      state.LANGUAGES_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_LANGUAGES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/languages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_LANGUAGES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_LANGUAGES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/languages';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_LANGUAGES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_LANGUAGES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/languages';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_LANGUAGES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/languages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_LANGUAGES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/languages/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}